define("ember-in-viewport/initializers/viewport-config", ["exports", "ember-in-viewport/utils/can-use-dom"], function (_exports, _canUseDom) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.initialize = initialize;
  0; //eaimeta@70e063a35619d71f0,"ember-in-viewport/utils/can-use-dom"eaimeta@70e063a35619d71f
  const defaultConfig = {
    viewportDidScroll: true,
    viewportSpy: false,
    viewportListeners: [{
      context: window,
      event: 'scroll'
    }, {
      context: window,
      event: 'resize'
    }],
    viewportTolerance: {
      top: 0,
      left: 0,
      bottom: 0,
      right: 0
    },
    intersectionThreshold: 0,
    scrollableArea: null // defaults to layout view (document.documentElement)
  };
  if (_canUseDom.default) {
    defaultConfig.viewportListeners.push({
      context: document,
      event: 'touchmove'
    });
  }
  function initialize() {
    const application = arguments[1] || arguments[0];
    const config = application.resolveRegistration('config:environment');
    const {
      viewportConfig = {}
    } = config;
    const mergedConfig = Object.assign({}, defaultConfig, viewportConfig);
    application.register('config:in-viewport', mergedConfig, {
      instantiate: false
    });
  }
  var _default = _exports.default = {
    name: 'viewport-config',
    initialize: initialize
  };
});